export type Tool = {
  href: string;
  eyebrow: string;
  title: string;
  description: string;
  brands: string[];
};

export const tools: Tool[] = [
  {
    href: "/tokens",
    eyebrow: "Public aggregates",
    title: "Token intelligence",
    description: "Public AI usage by provider, model, and tool.",
    brands: ["openai", "anthropic"],
  },
  {
    href: "/startups",
    eyebrow: "Watchlist",
    title: "Interesting startups",
    description: "AI infrastructure companies worth following.",
    brands: ["etched", "modal", "fireworks", "runpod"],
  },
];

